var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216,76H129.3335L100.5332,54.40039A12.07389,12.07389,0,0,0,93.3335,52H40A12.01343,12.01343,0,0,0,28,64V200a12.01343,12.01343,0,0,0,12,12H216a12.01343,12.01343,0,0,0,12-12V88A12.01343,12.01343,0,0,0,216,76ZM36,64a4.00458,4.00458,0,0,1,4-4H93.3335a4.02652,4.02652,0,0,1,2.3999.7998L121.333,80,95.7334,99.2002A4.02652,4.02652,0,0,1,93.3335,100H36ZM220,200a4.00458,4.00458,0,0,1-4,4H40a4.00458,4.00458,0,0,1-4-4V108H93.3335a12.07389,12.07389,0,0,0,7.1997-2.40039L129.3335,84H216a4.00458,4.00458,0,0,1,4,4Zm-64.00293-52a4.0002,4.0002,0,0,1-4,4h-20v20a4,4,0,0,1-8,0V152h-20a4,4,0,0,1,0-8h20V124a4,4,0,0,1,8,0v20h20A4.0002,4.0002,0,0,1,155.99707,148Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/add-folder.d4e34df6dda7c6ad25cd6e679877a5e7.svg";
export { ForwardRef as ReactComponent };